import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  return <main className="not-found-page" data-testid="not-found-page">
    <p className="eyebrow">NOT FOUND</p>
    <h1>This room<br />doesn’t exist.</h1>
    <p data-testid="not-found-message">The page may have moved, or the link may be incomplete.</p>
    <Link className="primary-button" data-testid="not-found-back-link" to="/jobs"><ArrowLeft size={17} /> Browse opportunities</Link>
  </main>;
}